import React, { createContext, useRef } from 'react';

export const ImageRecommendationCache = createContext(null);

export default function ImageRecommendationSession({ children, sessionKey }) {
  const session = useRef(null);
  if (!session.current || session.current.key !== sessionKey) {
    session.current = { key: sessionKey, cache: new Map() };
  }
  return <ImageRecommendationCache.Provider value={session.current.cache}>{children}</ImageRecommendationCache.Provider>;
}
